import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import PasswordGate from "@/components/PasswordGate";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import PageView from "@/pages/PageView";
import { Toaster } from "@/components/ui/sonner";

const Gate = () => (
  <div className="min-h-screen flex items-center justify-center bg-pillet-bg">
    <div className="w-8 h-8 border-2 border-pillet-sage border-t-transparent rounded-full animate-spin" />
  </div>
);

const Protected = () => {
  const { authed } = useAuth();
  if (authed === null) return <Gate />;
  if (!authed) return <PasswordGate />;
  return (
    <SiteProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/p/:slug" element={<PageView />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </SiteProvider>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Protected />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" richColors />
    </div>
  );
}

export default App;
